'use client'

import { cva, VariantProps } from 'class-variance-authority'
import { FC, HTMLAttributes } from 'react'

const textSkeleton = cva('skeleton-pulse w-full rounded-2', {
    variants: {
        as: {
            p: 'h-[15px]',
            h1: 'h-8',
            h2: 'h-7',
            h3: 'h-6',
            h4: 'h-5',
            h5: 'h-4',
            h6: 'h-3'
        }
    },
    defaultVariants: {
        as: 'h1'
    }
})

type TextSkeletonProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof textSkeleton>

const TextSkeleton: FC<TextSkeletonProps> = ({ as, className, ...props }) => (
    <div className={textSkeleton({ as, className })} {...props} />
)

export default TextSkeleton
